<template>
  <b-modal
    id="ai-assistant-modal"
    size="xl"
    title-tag="div"
    @shown="onShown"
    @hidden="onHidden"
  >
    <template #modal-title>
      <h5 class="mb-0">{{ trans('ai_robot') }}</h5>
      <small class="d-block text-muted">
        <small>{{ trans('ai_powered_by') }}</small>
      </small>
    </template>

    <b-row>
      <b-col>
        <p :class="!!messages ? 'text-muted' : ''">
          <i class="fa fa-fw fa-robot"></i>
          <strong>{{ trans('assistant') }}</strong>
          <br/>
          {{ trans('assistant_welcome') }}
        </p>
        <div v-if="!!messages">
          <div v-for="msg in messages" :key="msg.id" :class="msg.role == 'user' ? 'text-muted' : ''">
            <p class="mb-0">
              <i :class="`fa fa-fw fa-${msg.role == 'assistant' ? 'robot' : 'user'}`"></i>
              <strong>{{ trans(msg.role) }}</strong>
            </p>
            <div v-for="(item, i) in msg.content" :key="`content${i}`" v-if="!!item.text">
              <div v-html="markdownToHtml(item.text.value)" :class="msg.role != 'assistant' ? 'font-italic' : ''"></div>
              <div v-for="(annotation, a) in item.text.annotations" :key="`annotation${a}`" v-if="!!annotation.am_page_url">
                <small>
                  {{ annotation.text }}
                  <b-link :href="annotation.am_page_url" class="text-primary" target="_blank">
                    {{ annotation.am_page_name }}
                    <small><i class="fa fa-fw fa-external-link-alt"></i></small>
                  </b-link>
                </small>
              </div>
            </div>
          </div>
        </div>
        <p v-if="!!user_message && (!messages || busy)">
          <i class="fa fa-fw fa-user"></i>
          <strong>{{ trans('user') }}</strong>
          <br/>
          <em>{{ user_message }}</em>
        </p>
        <p v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
      </b-col>
    </b-row>

    <template #modal-footer>
      <b-row class="w-100" align-v="end">
        <b-col class="col-12 col-md px-0 mb-2">
          <b-form-textarea
            v-model="user_message"
            lazy
            :rows="1"
            :max-rows="4"
            :placeholder="trans('ai_ask_help')"
            :disabled="busy"
          ></b-form-textarea>
        </b-col>
        <b-col class="col-12 col-md-auto pl-0 pl-md-2 pr-0 mb-2">
          <b-button
            variant="primary"
            @click="onClickApply"
            block
            :disabled="busy"
          >
            {{ trans('send') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<style>
  #ai-assistant-modal.modal .modal-dialog .modal-body {
    height: 50vh;
    min-height: 50vh;
    max-height: 50vh;
    overflow-y: auto;
    padding: 1rem!important;
  }
  #ai-assistant-modal.modal .modal-dialog .modal-footer textarea {
    border-radius: 4px;
  }
</style>

<script>
  import {marked} from 'marked'

  export default {
    props: {
      organization: Object,
      initialMessage: String,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        user_message: null,
        messages: null,
      }
    },
    computed: {
      serialized() {
        return {
          text: this.user_message,
        }
      },
    },
    methods: {
      markdownToHtml(markdown) {
        let html = marked(markdown)
        return html.replace(/<a /g, '<a target="_blank" ')
      },
      onClickApply() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/assistant`
        axios.post(url, this.serialized)
        .then(response => {
          this.busy = false
          this.messages = response.data.data
          this.user_message = null
          this.$nextTick(this.scrollToBottom)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
        this.$nextTick(this.scrollToBottom)
      },
      scrollToBottom(delay) {
        setTimeout(() => {
          let el = document.querySelector('#ai-assistant-modal .modal-body')
          if (!!el) el.scrollTop = el.scrollHeight
        }, delay || 100)
      },
      onShown() {
        this.user_message = this.initialMessage || null
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.user_message = null
        this.messages = null
      }
    },
    mounted() {
      window.aiAssistantModal = this
    },
  }
</script>